/* The theme owns scrolling; this element aligns arrows and tracks the leftmost visible card. */
if (!customElements.get('moulp-collection-navigation')) {
  class MoulpCollectionNavigation extends HTMLElement {
    connectedCallback() {
      const stage = this.closest('.moulp-featured-collection__stage');
      if (!stage) return;
      this.slider = stage.querySelector('.slider');
      this.grid = stage.querySelector('.product-grid');
      const image = stage.querySelector('.image-cont, .product-block__image, .placeholder-image');
      if (!this.slider || !this.grid) return;

      this.updateLayout = () => {
        if (image) {
          const height = image.getBoundingClientRect().height;
          if (height > 0) this.style.setProperty('--moulp-nav-top', `${height / 2}px`);
        }
        this.updateVisibleCard();
      };
      this.scheduleUpdate = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updateLayout();
        });
      };
      this.slider.addEventListener('scroll', this.scheduleUpdate, { passive: true });
      this.observer = new ResizeObserver(this.scheduleUpdate);
      this.observer.observe(this.slider);
      this.observer.observe(this.grid);
      if (image) this.observer.observe(image);
      this.updateLayout();
    }

    updateVisibleCard() {
      const viewport = this.slider.getBoundingClientRect();
      if (viewport.width <= 0) return;
      let firstVisible = null;
      let leftmost = Infinity;
      for (const card of this.grid.children) {
        if (card.hidden) continue;
        const rect = card.getBoundingClientRect();
        if (rect.width > 0 && rect.right > viewport.left + 1 && rect.left < viewport.right - 1 && rect.left < leftmost) {
          firstVisible = card;
          leftmost = rect.left;
        }
      }
      if (!firstVisible) return;
      if (this.firstVisible !== firstVisible) {
        this.firstVisible?.classList.remove('moulp-first-visible');
        firstVisible.classList.add('moulp-first-visible');
        this.firstVisible = firstVisible;
      }
      this.grid.setAttribute('data-moulp-visible-card', '');
    }

    disconnectedCallback() {
      this.slider?.removeEventListener('scroll', this.scheduleUpdate);
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.firstVisible?.classList.remove('moulp-first-visible');
      this.firstVisible = null;
      this.grid?.removeAttribute('data-moulp-visible-card');
    }
  }
  customElements.define('moulp-collection-navigation', MoulpCollectionNavigation);
}
